import { ExpandableText } from '@components/molecules/ExpandableText'
import { scopedTranslation } from '@frontend/utils/I18n'

const t = scopedTranslation('views.calling_sessions.view_all_supporters.callback')

export function CallbackNote({ note }: { note: string }) {
  return <ExpandableText text={note} expandLabel={t('show_full_note')} />
}
